export default {
	section_banner: {
		title: {
			one: '支払い',
			two: '方法',
		},
		main_title: '& 資金へのアクセス',
		paragraph: {
			one: 'お客様は携帯電話だけで店舗で支払いができます。迅速かつ安全で、物理的なカードや現金は必要ありません。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	method_mid: {
		label: '合理化と簡素化',
		title: {
			one: 'JPWorldPay有料版 ',
			two: 'に',
			three: '所属',
			four: '店舗',
		},
		paragraph: {
			one: '関連会社ごとの決済またはすべての関連会社に対する決済により、ネットワーク全体で柔軟かつ効率的な支払い処理が可能になります。',
			two: '個々の口座管理からグループ全体の決済処理まで、JPWorldPayは財務業務を効率化・簡素化するツールを提供します。ビジネスニーズに合わせてカスタマイズされた、迅速、正確、そして透明性の高い決済をご活用ください。',
		},
		cta_buttons: {
			one: '支払いをする',
		},
	},

	withdraw_sec: {
		label: 'いつでも撤回可能',
		title: {
			one: 'の',
			two: '決済済み',
			three: 'ワンテザーとは',
			four: '修理済み',
		},
		paragraph:
			'JPWorldPayの決済額は固定されているため、取引の安定性と信頼性が確保されます。決済後は資金がすぐに利用可能になり、いつでも遅延なく引き出すことができます。この柔軟性により、資産を常に手元に置いておくことができるため、自信と利便性を持って資金を管理できます。JPWorldPayなら、常に資金を管理できます。隠れた条件や待機期間はなく、資金に迅速にアクセスできます。透明性と信頼に裏打ちされた経済的自由を体験してください。',
		cta_buttons: {
			one: '引き出した通貨',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
